import PortalIdParser from 'PortalIdParser';
export const getBaseUrl = () => '/documents';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;